'use strict';
module.exports = {
	push : function(properties, user, spa) {
        window.dataLayer = window.dataLayer || [];
        let layerData = {
            is_revamped: 'revamped',
            v2_pageProperties: {
                category: properties.category,
                subCategory: properties.subCategory
            }
        };

        if (properties.property) {
            layerData.properties = properties.property;
        }

        if (user) {
            layerData.v2_userId = user.accountId;
            layerData.v2_loginType = user.isVendor ? 'vendor' : 'user';
        }

        if (!this.checkDataLayer('originalLocation')) {
            layerData.originalLocation = document.location.protocol + '//' +
                                document.location.hostname +
                                document.location.pathname +
                                document.location.search
        }

        if (spa || this.checkDataLayer('event', 'gtm.historyChange')) {
            layerData.event = 'v2_spa_pageview'

            if (!this.checkDataLayer('v2_spa_referral') && typeof (window.google_tag_manager) != "undefined" && window.google_tag_manager['GTM-W9GZHRT']) {
                layerData.v2_spa_referral = window.google_tag_manager['GTM-W9GZHRT'].dataLayer.get('originalLocation');
            } else if(typeof (window.google_tag_manager) != "undefined" && window.google_tag_manager['GTM-W9GZHRT']) {
                layerData.v2_spa_referral = window.google_tag_manager['GTM-W9GZHRT'].dataLayer.get('originalLocationSPA');
            }

            layerData.originalLocationSPA = document.location.protocol + '//' +
                    document.location.hostname +
                    document.location.pathname +
                    document.location.search
        }
        window.dataLayer.push(layerData);
    },
    
    checkDataLayer : function($key, $val) {
        let res = false;
        let dlname;     
        if (typeof (window.google_tag_manager) != "undefined") {
            for (let i in window.google_tag_manager) {
                if(typeof(window.google_tag_manager[i])=="object" && window.google_tag_manager[i].gtmDom)
                    dlname = i;        
            }   
            for (let i in window[dlname]) {
                if (!$val & $val!='') {                
                    if (window[dlname][i][$key]) {
                        return true;
                    }
                } else {
                    if (window[dlname][i][$key] && window[dlname][i][$key] == $val) {
                        return true;
                    }
                }
            }
        }
        return res;
    },

    leads: function(properties) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'v2_leads',
            v2_leadsProperties: {
                type: properties.type,
                vendorId: properties.vendorId,
                vendorSlug: properties.vendorSlug
            }
        })
    },

    auth: function(event, type, payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event,
            v2_authentication_method: type,
            v2_userId: payload.user && payload.user.account.data.id || payload.vendor.account.data.id,
            v2_loginType: payload.user && payload.user.type || payload.vendor.type
        });
    },

    ppc: function(vendor) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            event: 'v2_ppc_click',
            ppcClickProperties: {
                vendorID: vendor.id,
                vendorSlug: vendor.slug,
                advertisementId: vendor.advertisement_id,
                categoryName: vendor.category && vendor.category.name
            }
        })
    }
}



// WEBPACK FOOTER //
// resources/peons/Datalayer.js